import type { EducationalInvestment } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const SECTION_STRINGS = appStrings.modules.educationalInvestment.sections;

export const useAgentContext = (
  targetEducationalInvestments: EducationalInvestment[],
  otherEducationalInvestments: EducationalInvestment[],
) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Target Educational Investments',
    description:
      "Education pathways most aligned with the user's career track, shown as cards with name, description, and tips to succeed.",
  });

  useRegisterAgentContext({
    kind: 'list',
    description: "Recommended educational investments for the user's career track",
    data: targetEducationalInvestments,
  });

  useRegisterAgentContext({
    kind: 'section',
    title: SECTION_STRINGS.educationTradeOff.title,
    description: SECTION_STRINGS.educationTradeOff.description,
    detail: [
      SECTION_STRINGS.educationTradeOff.content1,
      SECTION_STRINGS.educationTradeOff.content2,
    ].join('\n\n'),
  });

  useRegisterAgentContext({
    kind: 'list',
    description: 'Navigation cards linking to tools for improving education ROI',
    data: {
      [SECTION_STRINGS.educationTradeOff.imageCards.majorMalfunction.title]:
        SECTION_STRINGS.educationTradeOff.imageCards.majorMalfunction.description,
      [SECTION_STRINGS.educationTradeOff.imageCards.findScholarships.title]:
        SECTION_STRINGS.educationTradeOff.imageCards.findScholarships.description,
    },
  });

  useRegisterAgentContext({
    kind: 'section',
    title: SECTION_STRINGS.otherEducationalInvestments.title,
    description: SECTION_STRINGS.otherEducationalInvestments.description,
  });

  useRegisterAgentContext({
    kind: 'list',
    description: 'Other educational investment options',
    data: otherEducationalInvestments,
  });
};
